var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"box_bg"},[_c('div',{staticClass:"main"},[_c('Header',{staticStyle:{"z-index":"99"}}),_c('LeftNav'),_c('router-view',{style:(_vm.height)})],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }